import { Component } from '@angular/core';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.css'],
  standalone: false,
})
export class LandingPageComponent {
  platformList = [
    {
      img: 'assets/images/onboarding/ic_tpm.svg',
      title: 'TPM Portal',
    },
    {
      img: 'assets/images/onboarding/ic_pos.svg',
      title: 'POS',
    },
    // {
    //   img: 'assets/images/onboarding/ic_donation.svg',
    //   title: 'Donation',
    // },
    {
      img: 'assets/images/onboarding/ic_lister.svg',
      title: 'Lister',
    },
  ];
}
